// extracted by mini-css-extract-plugin
export default {"lower_header":"Lowerheade_lower_header__PZreG","menu":"Lowerheade_menu__9xJxB","menu_item":"Lowerheade_menu_item__52HiY"};